import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getDockReservations({ commit }, payload = {
        query: '',
        dockType: ''
    } ) {
        return axios
            .get(`/notification/dock-reservations${payload.query}`)
            .then(response => {
                commit('GET_DOCK_RESERVATIONS_SUCCESS', {reservations: response.data.results, dockType: payload.dockType})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDockReservation(context, dockReservationId) {
        return axios
            .get(`/notification/dock-reservations/${dockReservationId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do rezerwacji ${dockReservationId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    getDockClipboardReservations({ commit }, payload = {
        query: '',
        dockType: ''
    } ) {
        return axios
            .get(`/notification/dock-clipboard-reservations${payload.query}`)
            .then(response => {
                commit('GET_DOCK_CLIPBOARD_RESERVATIONS_SUCCESS', {reservations: response.data.results, dockType: payload.dockType})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rezerwacji znajdujących się w schowku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getClipboardReservation(context, reservationId) {
        return axios
            .get(`/notification/dock-clipboard-reservations/${reservationId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDockOccupation(context, payload = {
        customerId: '',
        date: '',
        dockId: ''
    }) {
        return axios
            .get(`/notification/occupation/${payload.customerId}/${payload.dockId}${payload.date}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie dostępnych dat nie powiodło się.')

                return Promise.reject(error)
            })
    },
    saveNotification({ commit }, notificationData) {
        return axios
            .post('/notification/dock-reservations', notificationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została dodana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateNotification({ commit }, notificationData) {
        return axios
            .put(`/notification/dock-reservations/${notificationData.id}`, notificationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została zedytowana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja rezerwacji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    updateClipboardNotification({ commit }, notificationData) {
        return axios
            .put(`/notification/dock-clipboard-reservations/${notificationData.id}`, notificationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została zedytowana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja rezerwacji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteNotification({ commit }, notificationId) {
        return axios
            .delete(`/notification/dock-reservations/${notificationId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została usunięta.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteClipboardNotification({ commit }, notificationId) {
        return axios
            .delete(`/notification/dock-clipboard-reservations/${notificationId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została usunięta.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDocksDicts({ commit }, payload = {
        query: ''
    }) {
        return axios
            .get(`/notification/docks/dicts/docks${payload.query}`)
            .then(response => {
                commit('GET_DOCKS_DICTS_SUCCESS', response.data.results)

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie doków nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDocks({ commit }, {
        paginate = '',
        query = '',
    } = {}) {
        commit('GET_DOCKS_REQUEST')

        return axios
            .get(`/notification/docks${paginate}${query}`)
            .then(response => {
                commit('GET_DOCKS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DOCKS_FAILURE')
                handleApiError(error, 'Pobranie doków nie powiodło się.')

                return Promise.reject(error)
            })
    },
   
    getDock(context, dockId) {
        return axios
            .get(`/notification/docks/${dockId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych doku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createDock({ commit }, payload) {
        return axios
            .post('/notification/docks', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dok został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie doku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateDock({ commit }, payload) {
        return axios
            .put(`/notification/docks/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dok został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja doku nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getStores({ commit }, {
        paginate = '',
        query = '',
    } = {}) {
        commit('GET_STORES_REQUEST')

        return axios
            .get(`/notification/stores${paginate}${query}`)
            .then(response => {
                commit('GET_STORES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_STORES_FAILURE')
                handleApiError(error, 'Pobranie magazynów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDockTypes({ commit }) {
        return axios
            .get('/notification/docks/dicts/dock-types')
            .then(response => {
                commit('GET_DOCK_TYPES_SUCCESS', response.data.results)

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów doków nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReservationStatuses({ commit }) {
        return axios
            .get('/notification/dock-reservations/dicts/statuses')
            .then(response => {
                commit('GET_RESERVATION_STATUSES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    clearDocks({ commit }) {
        commit('CLEAR_DOCKS')
    },
    clearDockTypes({ commit }) {
        commit('CLEAR_DOCK_TYPES')
    },
    setBusinessHours({ commit }, payload) {
        commit('SET_BUSINESS_HOURS', payload)
    },
    clearBusinessHours({ commit }) {
        commit('CLEAR_BUSINESS_HOURS')
    },
    setUser({ commit }, userData) {
        commit('SET_USER_DATA', userData)
    },
    setAvailableHoursForSelectedDay({ commit }, payload) {
        commit('SET_AVAILABLE_HOURS_FOR_SELECTED_DAY', payload)
    },
    clearAvailableHoursForSelectedDay({ commit } ) {
        commit('CLEAR_AVAILABLE_HOURS_FOR_SELECTED_DAY')
    }
}